exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".progressDisplay .timeSpanTitle{font-size:1.4em}.progressDisplay .pointsTotal{font-size:.8em;margin-bottom:5px}.progressDisplay .progress{width:75%;margin-bottom:10px}.progressDisplay .fullReportLink{font-size:.8em;display:none}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/sass-loader/dist/cjs.js!./assets/sass/users/students/progress_display.scss
// module id = 1430
// module chunks = 0